import { useState, useEffect } from "react";
import AccordionCard from "../AccordionCard";
import { PiCircuitryBold } from "react-icons/pi";
import {
  getCDKStatusInformation,
  setCancellationPending,
} from "../../services/cdkOrderService";
import handleApiError from "../../helpers/handleApiError";
import { cdkSubscriptionStatuses, viewStates } from "../../constants";
import { Modal } from "react-bootstrap";
import { format as dateFormat, parseISO } from "date-fns";
import {
  calculateDifferenceInMonths,
  cdkTerms,
  determineCDKTermByStartDate,
  determineEndOfCDKTerm,
  determineEndOfCDKTermByMonthsPassed,
  determineFinalizeCancellationEndDate,
} from "../../helpers/integrationsUtilities";

export const SubscriptionManagement = ({ history }) => {
  const [viewState, setViewState] = useState(viewStates.loading);
  const [cdkStatusInfo, setCDKStatusInfo] = useState({
    status: {
      subscriptionStatus: cdkSubscriptionStatuses.notSubscribed,
      since: null,
    },
    history: [],
  });

  useEffect(() => {
    const fetchCDKStatusInfo = async () => {
      try {
        if (viewState !== viewStates.loading) {
          setViewState(viewStates.loading);
        }
        const cdkStatusInfoResponse = await getCDKStatusInformation();
        // console.log(cdkStatusInfoResponse);
        setCDKStatusInfo({
          status: {
            subscriptionStatus:
              cdkStatusInfoResponse.data.cdkStatus?.subscriptionStatus ??
              cdkSubscriptionStatuses.notSubscribed,
            since: cdkStatusInfoResponse.data.cdkStatus?.lastUpdated,
          },
          history: cdkStatusInfoResponse.data?.cdkHistory,
        });
        setViewState(viewStates.success);
      } catch (ex) {
        if (ex.response?.status === 400) {
          // setCDKStatusInfo(cdkStatusInfoResponse.data);
          setCDKStatusInfo({
            subscriptionStatus: cdkSubscriptionStatuses.notSubscribed,
            since: null,
          });
          setViewState(viewStates.success);
        } else {
          handleApiError(ex, history);
          setViewState(viewStates.error);
        }
      }
    };
    fetchCDKStatusInfo();
  }, []);

  const [
    showCancellationConfirmationModal,
    setShowCancellationConfirmationModal,
  ] = useState(false);
  const [sendingCancellation, setSendingCancellation] = useState(false);
  const handleClickCancelSubscription = () => {
    setShowCancellationConfirmationModal(true);
  };
  const handleCloseCancellationConfirmationModal = () => {
    setShowCancellationConfirmationModal(false);
  };
  const handleClickConfirmCancellation = async () => {
    try {
      setSendingCancellation(true);
      const cancellationResponse = await setCancellationPending();
      history.go(0); //refresh to reftech cdkSubscriptionStatus
    } catch (ex) {
      handleApiError(ex, history);
      setSendingCancellation(false);
    } finally {
    }
  };

  // START DATE is NOT the since date because when pending cancellation the since date is when the cancellation was requested and not the date the subscription started
  // const startDate = parseISO(cdkStatusInfo.status.since);
  // const currentDate = new Date();
  // const currentTerm = determineCDKTermByStartDate(startDate);
  // const monthsPassed = calculateDifferenceInMonths(currentDate, startDate);
  // const endOfCurrentTerm = determineEndOfCDKTerm(startDate, monthsPassed);

  return (
    <AccordionCard
      eventKey={"subscriptionManagement"}
      title="Subscription Management"
      icon={() => (
        <PiCircuitryBold
          style={{
            fontSize: "24px",
            marginRight: "10px",
            transform: "rotate(270deg)",
          }}
        />
      )}
    >
      <Modal
        show={showCancellationConfirmationModal}
        onHide={handleCloseCancellationConfirmationModal}
      >
        <Modal.Header>
          <Modal.Title>Cancel CDK Subscription</Modal.Title>
        </Modal.Header>
        {!sendingCancellation && (
          <>
            <Modal.Body>
              Are you sure you wish to cancel your subscription?
              {/* <br />
              Your service will continue until{" "}
              {dateFormat(
                determineFinalizeCancellationEndDate(
                  currentDate,
                  startDate,
                  currentTerm
                ),
                "MM/dd/yyyy"
              )}
              . */}
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCloseCancellationConfirmationModal}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleClickConfirmCancellation}
                disabled={sendingCancellation}
              >
                Confirm Cancellation
              </button>
            </Modal.Footer>
          </>
        )}
        {sendingCancellation && (
          <Modal.Body>Submitting cancellation request...</Modal.Body>
        )}
      </Modal>

      <div className="px-3">
        {viewState === viewStates.success && (
          <div className="row">
            <div className="col-9">
              <h5>CDK Integration</h5>
              <div
              //   className="px-2"
              >
                <div>
                  <span className="font-600">Status </span>
                  {cdkStatusInfo.status?.subscriptionStatus}
                </div>
                <div>
                  {/* {dateFormat(parseISO(cdkStatusInfo.status.lastUpdated), "MM-dd-yy")} */}
                </div>

                {cdkStatusInfo.status?.since && (
                  <>
                    <div>
                      <span className="font-600">Since </span>
                      {dateFormat(
                        parseISO(cdkStatusInfo.status?.since),
                        "MM/dd/yyyy"
                      )}
                    </div>
                  </>
                )}
                {/* {(cdkStatusInfo.status.subscriptionStatus ===
                  cdkSubscriptionStatuses.active ||
                  cdkStatusInfo.status.subscriptionStatus ===
                    cdkSubscriptionStatuses.cancellationPending) && (
                  <>
                    <div>
                      <span className="font-600">Current Term </span>
                      {currentTerm}
                    </div>
                    {currentTerm !== cdkTerms.monthly && (
                      <div>
                        <span className="font-600">Ends on </span>
                        {dateFormat(endOfCurrentTerm, "MM/dd/yyyy")}
                      </div>
                    )}
                  </>
                )} */}
                {cdkStatusInfo.status?.subscriptionStatus ===
                  cdkSubscriptionStatuses.active && (
                  <div>
                    <button
                      type="button"
                      className="btn btn-danger mt-4"
                      onClick={handleClickCancelSubscription}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </AccordionCard>
  );
};
